export default __webpack_public_path__ + "static/media/cloud-server.464792ca.svg";